// Shared small components used across multiple pages
import { useAuth } from "../context/AuthContext";
const STATUS_LABEL = {
  submitted:          "Submitted",
  sent_to_production: "Sent to Production",
  pulled:             "Pulled",
  ready_for_pickup:   "Ready for Pickup",
  picked_up:          "Picked Up",
  ready_to_invoice:   "Ready to Invoice",
  invoiced:           "Invoiced",
  paid:               "Paid",
};
// Franchisees never see internal invoicing stages as a received invoice.
const FRANCHISEE_LABEL = { ready_to_invoice: "Picked Up", invoiced: "Invoice Received", paid: "Paid" };

const STATUS_CLS = {
  submitted:          "status-received",
  sent_to_production: "status-progress",
  pulled:             "status-progress",
  ready_for_pickup:   "status-ready",
  picked_up:          "status-fulfilled",
  ready_to_invoice:   "status-fulfilled",
  invoiced:           "status-fulfilled",
  paid:               "status-fulfilled",
};

export function StatusBadge({ status }) {
  const { user } = useAuth();
  const shown = user?.role === "franchisee" && status === "ready_to_invoice" ? "picked_up" : status;
  const cls = STATUS_CLS[shown] || "bg-muted text-foreground";
  return (
    <span className={`text-[11px] px-2.5 py-1 rounded-full font-medium tracking-wide ${cls}`}>
      {(user?.role === "franchisee" && FRANCHISEE_LABEL[status]) || STATUS_LABEL[status] || status}
    </span>
  );
}

export { STATUS_LABEL };
